const sharedTokens = {
  fonts: {
    primary: 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  transitions: {
    default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    slow: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  },
  zIndex: {
    background: 1,
    content: 2,
    overlay: 3,
    navigation: 100,
    modal: 1000,
  },
};

export const darkTheme = {
  ...sharedTokens,
  colors: {
    primary: '#7dd3fc',
    primaryDark: '#60a5fa',
    primaryLight: '#bae6fd',
    secondary: '#60a5fa',
    background: '#0f1724',
    backgroundCard: '#0b1220',
    cardBackground: '#0b1220',
    text: '#ffffff',
    textSecondary: '#9aa4b2',
    muted: '#9aa4b2',
    white: '#ffffff',
    overlay: 'rgba(15,23,36,0.95)',
    overlayLight: 'rgba(15,23,36,0.8)',
    glass: 'rgba(255,255,255,0.03)',
    accent: '#7dd3fc',
    gradients: {
      primary: 'linear-gradient(135deg, #7dd3fc 0%, #60a5fa 100%)',
      background: 'linear-gradient(180deg,#071024 0%, #071824 100%)',
      overlay: 'linear-gradient(135deg, rgba(15,23,36,0.95) 0%, rgba(11,18,32,0.9) 100%)',
      overlayLight: 'linear-gradient(135deg, rgba(15,23,36,0.8) 0%, rgba(11,18,32,0.75) 100%)',
      current: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      research: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      teaching: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
      leadership: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    },
  },
  shadows: {
    card: '0 8px 32px rgba(0,0,0,0.3)',
    text: '0 2px 4px rgba(0,0,0,0.5)',
    hover: '0 20px 60px rgba(0,0,0,0.4)',
  },
};

export const lightTheme = {
  ...sharedTokens,
  colors: {
    primary: '#0369a1',
    primaryDark: '#075985',
    primaryLight: '#7dd3fc',
    secondary: '#0284c7',
    background: '#f0f6ff',
    backgroundCard: '#ffffff',
    cardBackground: '#ffffff',
    text: '#0f172a',
    textSecondary: '#334155',
    muted: '#64748b',
    white: '#0f172a',
    overlay: 'rgba(240,246,255,0.96)',
    overlayLight: 'rgba(240,246,255,0.8)',
    glass: 'rgba(0,0,0,0.02)',
    accent: '#0369a1',
    gradients: {
      primary: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
      background: 'linear-gradient(180deg, #f0f6ff 0%, #dbeafe 100%)',
      overlay: 'linear-gradient(135deg, rgba(240,246,255,0.96) 0%, rgba(219,234,254,0.9) 100%)',
      overlayLight: 'linear-gradient(135deg, rgba(240,246,255,0.8) 0%, rgba(219,234,254,0.75) 100%)',
      current: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      research: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      teaching: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
      leadership: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    },
  },
  shadows: {
    card: '0 8px 32px rgba(0,0,0,0.08)',
    text: '0 2px 4px rgba(0,0,0,0.1)',
    hover: '0 20px 60px rgba(0,0,0,0.12)',
  },
};

// Backward-compat alias
export const theme = darkTheme;